export const matchSearch = (source = '', searchString = '') =>
  source.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
